import { render, staticRenderFns } from "./family-detail.vue?vue&type=template&id=686d25ae&scoped=true"
import script from "./family-detail.vue?vue&type=script&lang=js"
export * from "./family-detail.vue?vue&type=script&lang=js"
import style0 from "./family-detail.vue?vue&type=style&index=0&id=686d25ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686d25ae",
  null
  
)

export default component.exports